import {makeThemeProps} from "@themes/default/props/utils";

export default (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getHeaderProps(theme);
};

export const loginButtonStyles = (theme, props, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getHeaderLoginButtonProps(theme, props);
};

export const searchButtonStyles = (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getHeaderSearchButtonProps(theme);
};

export const cartButtonStyles = (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getHeaderCartButtonProps(theme);
};

export const cartButtonBadgeStyles = (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getHeaderCartBadgeProps(theme);
};
